import { useEffect } from 'react';

interface SeoConfig {
  title: string;
  description: string;
}

export function useTitle({ title, description }: SeoConfig) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;

    // Update or create meta description
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    const previousDesc = metaDesc?.content || '';
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = description;

    return () => {
      document.title = previousTitle;
      if (metaDesc) metaDesc.content = previousDesc;
    };
  }, [title, description]);
}